(function () {
  function px(n) {
    var v = Math.max(0, Math.round(Number(n) || 0));
    return v + "px";
  }

  function getVisibleHeight(el) {
    if (!el) return 0;
    var style = window.getComputedStyle(el);
    if (style.display === "none" || style.visibility === "hidden") return 0;
    var rect = el.getBoundingClientRect();
    return rect && rect.height ? rect.height : 0;
  }

  function updateDrawerOffset() {
    var headerEl = document.querySelector(".inkblox-header__container");
    var promoEl = document.querySelector(".promo-banner");

    var headerH = getVisibleHeight(headerEl) || 88;
    var promoH = getVisibleHeight(promoEl) || 0;

    document.documentElement.style.setProperty("--inkblox-header-height", px(headerH));
    document.documentElement.style.setProperty("--inkblox-promo-height", px(promoH));
  }

  function init() {
    updateDrawerOffset();

    window.addEventListener("resize", updateDrawerOffset);

    // Catch dynamic banner render (theme editor / A/B / locale switch etc.)
    var mo = new MutationObserver(function () {
      updateDrawerOffset();
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });

    // Re-check after everything is painted (fonts/images can change heights a bit)
    window.addEventListener("load", updateDrawerOffset);
    setTimeout(updateDrawerOffset, 250);
    setTimeout(updateDrawerOffset, 1000);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
